import Mousetrap from 'mousetrap';
import pausePlugin from './pausePlugin';
import recordPlugin from './recordPlugin';
import allowNativeKeysPlugin from './allowNativeKeysPlugin';

function createNoopMousetrap() {
  const noop = () => {};
  return {
    bind: noop,
    unbind: noop,
    pause: noop,
    unpause: noop,
    reset: noop,
    record: noop,
    stopRecord: noop,
    startRecording: noop,
  };
}

function resolveMousetrap(input) {
  if (input?.prototype?.stopCallback) {
    return input;
  }

  if (input?.default?.prototype?.stopCallback) {
    return input.default;
  }

  if (globalThis?.Mousetrap?.prototype?.stopCallback) {
    return globalThis.Mousetrap;
  }

  return null;
}

const resolvedMousetrap = resolveMousetrap(Mousetrap);

if (resolvedMousetrap) {
  recordPlugin(resolvedMousetrap);
  pausePlugin(resolvedMousetrap);
  // Registered after pausePlugin so its stopCallback wraps the pause check:
  // while paused, still stop; otherwise stop only for keystrokes landing in a
  // modal dialog or an `.ohif-text-select` region, where the browser's own
  // keyboard behaviour should win.
  allowNativeKeysPlugin(resolvedMousetrap);
}

export default resolvedMousetrap ?? createNoopMousetrap();
